import { ContentType, RoleContent } from '.'
export const stories: Record<string, ContentType[][]> = {
  intro: [
    [
      {
        text: `乘坐上「星語列車」，窗外似乎飄著今年冬天的第一場初雪。傳說中，初雪降臨的夜晚，這列車會載著有緣人前往一座遺世的古老樂園。在那座樂園裡，隱藏著「星石」—一顆擁有不可思議力量的古老寶石。`,
      },
    ],
    [
      {
        text: `據說，星石曾見證過一段無法被遺忘的愛戀，卻因歲月變遷而化作六片散落的記憶碎片，等待有緣人前來將它們拼湊重生。`,
      },
    ],
    [
      {
        text: `就在此刻，連接隔壁車廂的門緩緩打開，一位讓你心跳加速的男子走了進來。他是……`,
      },
    ],
  ],
}
